export const reactClass = (className?: string) =>
  className
    ? className
        .split(' ')
        .map((s) => `react-app-${s}`)
        .join(' ')
    : ''
